module.exports = __webpack_public_path__ + "img/RedFailureTriangle.6051a392.svg";